import { Radio, useTheme } from '@mui/material';

const RenderRadio = ({
  activeRadio,
  handleRadio,
  indexLeg,
  object_option,
  next_cluster,
  next_leg_options,
}) => {
  const theme = useTheme();

  return (
    <Radio
      checked={activeRadio}
      onClick={e => {
        e.stopPropagation();
        handleRadio(indexLeg, object_option, next_leg_options, next_cluster);
      }}
      sx={{
        '&.Mui-checked': { color: theme.tertiary },
      }}
    />
  );
};

export default RenderRadio;
